// Запись, к которой привязаны реплики разбора. Тайм-коды реплик считаются от
// начала той же записи, из которой разбор доставал звук, поэтому клик по
// реплике просто перематывает плеер. Видео важнее: на нём видно собеседника.
// Звук берём, только если видео нет, а отдельная аудиозапись есть.
// Ссылка на страницу хостинга (Google Диск, YouTube) - не запись: плеер её не
// проиграет и останется чёрным, поэтому такое видео пропускаем.

import {readVideoSource} from '../VideoPreview/videoSource';

function firstUrl(values) {
    for (let value of values) {
        if (typeof value === 'string' && value.trim()) return value.trim();
        if (value && typeof value === 'object' && typeof value.url === 'string' && value.url.trim()) {
            return value.url.trim();
        }
    }
    return '';
}

// uploadPreview - ссылка на сжатую копию загруженной записи (useVideoPreview):
// у загрузки нет item.video, и без неё плеер играл только звук, хотя видео есть.
export function pickDialogMedia(interview, analysis, uploadPreview) {
    let item = interview && typeof interview === 'object' ? interview : {};
    let state = analysis && typeof analysis === 'object' ? analysis : {};
    let result = state.result && typeof state.result === 'object' ? state.result : {};
    let media = result.media && typeof result.media === 'object' ? result.media : {};

    // item.videoUpload - числовой id записи UploadVideo (Interview.videoUpload),
    // не прямая ссылка: firstUrl всё равно отсеет его как невалидный источник.
    // Прямая ссылка на запись для плеера приходит только как media.videoUrl/video
    // (аудио/видео сервиса разбора) или старым текстовым Interview.video.
    let video = firstUrl([item.video, uploadPreview, media.videoUrl, media.video]
        .filter(value => {
            let source = readVideoSource(value && typeof value === 'object' ? value.url : value);
            return source && source.kind === 'direct';
        }));
    if (video) return {kind: 'video', src: video};

    let audio = firstUrl([
        item.audio, item.audioUrl, item.uploadAudio,
        state.audioUrl, result.audioUrl, result.audio, media.audioUrl, media.audio,
    ]);
    if (audio) return {kind: 'audio', src: audio};

    return null;
}

// Реплика, которая звучит в момент ms. Конец реплики может не прийти -
// тогда она длится до начала следующей. Паузы между репликами ничего не подсвечивают.
export function turnIndexAt(turns, ms) {
    let list = Array.isArray(turns) ? turns : [];
    let time = Number(ms);
    if (!Number.isFinite(time)) return -1;
    for (let i = 0; i < list.length; i++) {
        let turn = list[i] || {};
        let start = Number(turn.startMs);
        if (!Number.isFinite(start) || time < start) continue;
        let next = list[i + 1] && Number(list[i + 1].startMs);
        let end = Number.isFinite(Number(turn.endMs)) && Number(turn.endMs) > start
            ? Number(turn.endMs)
            : Number.isFinite(next) ? next : Infinity;
        if (time < end) return i;
    }
    return -1;
}

// Плеер по умолчанию закреплён и висит над лентой при скролле. Открепить его
// можно кнопкой под записью - тогда он уезжает вместе с контентом. Выбор
// запоминается в браузере, чтобы не откреплять заново на каждом интервью.
export const PLAYER_PINNED_KEY = 'dialogPlayerPinned';

export function readPlayerPinned(storage) {
    try {
        return (storage || window.localStorage).getItem(PLAYER_PINNED_KEY) !== 'false';
    } catch (e) {
        return true;
    }
}

export function savePlayerPinned(pinned, storage) {
    try {
        (storage || window.localStorage).setItem(PLAYER_PINNED_KEY, pinned ? 'true' : 'false');
    } catch (e) {}
}

// Видео можно слушать как аудиодорожку: переключатель «Только аудио» прячет
// картинку и ставит вместо неё компактный аудиоплеер. Выбор тоже запоминается.
export const PLAYER_AUDIO_ONLY_KEY = 'dialogPlayerAudioOnly';

export function readPlayerAudioOnly(storage) {
    try {
        return (storage || window.localStorage).getItem(PLAYER_AUDIO_ONLY_KEY) === 'true';
    } catch (e) {
        return false;
    }
}

export function savePlayerAudioOnly(audioOnly, storage) {
    try {
        (storage || window.localStorage).setItem(PLAYER_AUDIO_ONLY_KEY, audioOnly ? 'true' : 'false');
    } catch (e) {}
}

// Чем играть запись: видео превращается в аудио только по переключателю,
// у аудиозаписи картинки нет вовсе.
export function playerView(media, audioOnly) {
    if (!media) return 'none';
    return media.kind === 'video' && !audioOnly ? 'video' : 'audio';
}
